export default __webpack_public_path__ + "static/media/sol-dvss-QuaseTodooTempo.c38cc83b.jpeg";